module.exports = __webpack_public_path__ + "static/img/page7-block.408989e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page7-block.png
// module id = fxbK
// module chunks = 216